import { createRoot } from "react-dom/client";

import { App } from "./App";
import { LivemapUI } from "livemap-ui";
import { createHashHistory } from "history";
import { Router } from "react-router";
import { ToastProvider } from "./contexts/toast";

const history = createHashHistory();

const root = createRoot(document.getElementById("root")!);
root.render(
  <LivemapUI mode="day">
    <ToastProvider>
      <Router history={history}>
        <App />
      </Router>
    </ToastProvider>
  </LivemapUI>
);
